import api from './client';
import type { AuthUser } from '../context/AuthContext';

export const guestLogin = async (): Promise<{ access_token: string; user: AuthUser }> => {
  const response = await api.post('/auth/guest');
  return response.data;
};

export const adminLogin = async (username: string, password: string): Promise<{ access_token: string; user: AuthUser }> => {
  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);
  const tokenResponse = await api.post('/auth/token', formData);
  const access_token = tokenResponse.data.access_token;

  // /auth/token возвращает только токен — отдельно запрашиваем данные пользователя
  const userResponse = await api.get('/auth/me', {
    headers: { Authorization: `Bearer ${access_token}` },
  });

  return { access_token, user: userResponse.data };
};

export const getMe = async (): Promise<AuthUser> => {
  const response = await api.get('/auth/me');
  return response.data;
};

export const refreshToken = async (): Promise<string> => {
  const response = await api.post('/auth/refresh');
  return response.data.access_token;
};

export const logoutApi = async (): Promise<void> => {
  await api.post('/auth/logout');
};
